<script>
export default {
  data() {
    return {
      switchCost: 'year',
      list: [
        {
          img: require('@assets/images/plan/basic.svg'),
          title: '客戶管理小資方案',
          year: {
            money: '$9,600',
            count: '/年',
            plan: ['提供公版官網', '單店設定', '管理帳號1個', '雲端服務', 'iPet免費網域', '數據分析', '官方Line預約', '優惠券功能'],
          },
          month: {
            money: '$900',
            count: '/月',
            plan: ['提供公版官網', '單店設定', '管理帳號1個', '雲端服務', 'iPet免費網域', '數據分析', '官方Line預約', '優惠券功能'],
          },
          to: '',
        },
        {
          img: require('@assets/images/plan/add-on.svg'),
          title: '線上預約系統方案',
          year: {
            money: '$20,000',
            count: '/年',
            plan: [
              '單店設定',
              '簡訊通知100封/月',
              '優惠券功能',
              '管理帳號5個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '分店可升級成專業',
              '官方Line預約',
              '多元付款金流串接（可收費開通）',
              '數據分析',
            ],
          },
          month: {
            money: '$2,400',
            count: '/月',
            plan: [
              '單店設定',
              '簡訊通知100封/月',
              '優惠券功能',
              '管理帳號5個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '分店可升級成專業',
              '官方Line預約',
              '多元付款金流串接（可收費開通）',
              '數據分析',
            ],
          },
          to: 'reserveplan',
        },
        {
          img: require('@assets/images/plan/intermediate.svg'),
          title: '專業店家方案',
          year: {
            money: '$36,000',
            count: '/年',
            plan: [
              '多店設定',
              '額外新增單間分店$10,000/年（含簡訊300封、管理帳號8個）',
              '簡訊通知300封/月',
              '優惠券功能',
              '管理帳號8個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '商品POS',
              '多元付款金流串接',
              '數據分析',
            ],
            // starPlan: ['專業行銷顧問團隊', '店門形象拍攝', '行銷設計', '多元付款金流串接（進階方案）', '本地商家資訊建置'],
          },
          month: {
            money: '$3,600',
            count: '/月',
            plan: [
              '多店設定',
              '額外新增單間分店$10,000/年（含簡訊300封、管理帳號8個）',
              '簡訊通知300封/月',
              '優惠券功能',
              '管理帳號8個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '商品POS',
              '多元付款金流串接',
              '數據分析',
            ],
            // starPlan: ['專業行銷顧問團隊', '店門形象拍攝', '行銷設計', '多元付款金流串接（進階方案）', '本地商家資訊建置'],
          },
          to: 'marketingplan',
        },
      ],
    }
  },
  methods: {
    handleClick(tab, event) {

    },
    setPlanMoney(item) {
      if (this.switchCost === 'month') {
        return item.month
      }else {
        return item.year
      }
    }
  },
}
</script>

<template>
  <div :class="$style.sectionPlan">
    <div class="section">
      <div class="container">
        <div class="sectionPlan__toggle">
          <BaseSectionTitle 
            title="預約系統方案" 
            sub-title="Reservation System" 
            class="isStyleDecoration text-lg-left text-center islgCenter mx-lg-0 mx-auto mb-md-0"
          />
          <el-tabs 
            v-model="switchCost" 
            stretch 
            class="isStyleBase isBigWidth"
            @tab-click="handleClick"
          >
            <el-tab-pane label="年繳" name="year"></el-tab-pane>
            <el-tab-pane label="月繳" name="month"></el-tab-pane>
          </el-tabs>
          
        </div>
        <div class="row">
          <div
            v-for="(item, $index) in list"
            :key="$index"
            class="col-lg-4 col-12 sectionPlan__item"
          >
            <BasePlan 
              :img="item.img"
              :title="item.title"
              :money=setPlanMoney(item)
              :list="item[switchCost].plan"
              is-show-contact
              :to="item.to"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .sectionPlan {
    position: relative;
    z-index: 3;
    top: -130px;
    &:before {
      content:'';
      position: absolute;
      bottom:-9%;
      background-image: url('@assets/images/home/section3-bg.svg');
      padding-bottom: 39%;
      background-repeat: no-repeat;
      background-size: cover;      
      width: 100vw;
      left: 0;
      @include max-xl {
        bottom:-6%;  
        background-position: 0;
      }
      @include max-md {
        bottom: -2%;  
        background-position: 0;
      }
      // @include max-md {
      //   bottom: -9%;
      //   background-position: 25%;
      // }
      // @include max-xl {
      //   padding-bottom: 0;
      //   height: 100%;
      // }
    }
    @include max-lg {
      top: 0;
      padding-top: 100px;
    }
    :global {
      .sectionPlan {
        &__toggle {
          // margin-top: 60px;
          margin-bottom: 10rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          @include max-lg {
            margin-bottom: 20px;
          }
          @include max-md {
            flex-direction: column;
          }
        }
        &__item {
          position: relative;
          z-index: 3;
          @include max-lg {
             margin-top: 110px;
          }
        }
        &__content {
          margin-top: 30px;
          margin-bottom: 100px;
          font-size: 14px;
          color: $color-text-2;
          line-height: 1.75;
        }
      }
      .el-tabs__nav-wrap {
        margin-left: auto;
        @include max-lg {
          margin: 0 auto;
        }
      }
    }
  }
</style>